const data = [
  {
    question: "We ___ to school every day.",
    incorrectAnswers: ["gos", "goes"],
    correctAnswer: "go",
  },
  {
    question: "He will come __a quarter past six.",
    incorrectAnswers: ["in", "on"],
    correctAnswer: "at",
  },
  {
    question: "What __________ on Saturdays?",
    incorrectAnswers: ["are you doing", "you do"],
    correctAnswer: "do you do",
  },
  {
    question: "Look! What ________? ",
    incorrectAnswers: ["do he do", "does he do"],
    correctAnswer: "is he doing",
  },

  {
    question: "Rome is ________ city I’ve ever seen!",
    incorrectAnswers: ["the beautifullest", "the more beautiful"],
    correctAnswer: "the most beautiful",
  },
  {
    question: "____________ your homework yet?",
    incorrectAnswers: ["did you finish", "are you finishing"],
    correctAnswer: "have you finished",
  },
  {
    question: "Rainforests _____down.",
    incorrectAnswers: ["cut", "cutting"],
    correctAnswer: "are cut",
  },
  {
    question: "She was very tired, ___ she couldn’t sleep.",
    incorrectAnswers: ["despite", "though"],
    correctAnswer: "yet",
  },
  {
    question: "He ___ be famous. I’ve never heard of him.",
    incorrectAnswers: ["mustn’t", "must"],
    correctAnswer: "can’t",
  },
  {
    question: "I live in a big city, so I _______ busy traffic.",
    incorrectAnswers: ["get used to", "used to"],
    correctAnswer: "am used to",
  },
  {
    question: "He was tired, because he _______ in the garden.",
    incorrectAnswers: ["has been working", "had worked"],
    correctAnswer: "had been working",
  },
  {
    question: "We should use ____ time we have to discuss the problem.",
    incorrectAnswers: ["little", "little the"],
    correctAnswer: "the little ",
  },
  {
    question: "Your eyes are red, ___________?",
    incorrectAnswers: ["did you cry", "have you cried"],
    correctAnswer: "have you been crying",
  },
  {
    question:
      "“Michael Jordan is visiting our school next week to talk about basketball. You mean __Michael Jordan? Can you get his autograph for me?”",
    incorrectAnswers: ["-", "a"],
    correctAnswer: "the",
  },
  {
    question: "We were delayed ____ an accident.",
    incorrectAnswers: ["because", "of because"],
    correctAnswer: "because of",
  },
];

export default data;
